import { useEffect } from "react";

const useScript = ({ contentId, onLoad }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `//player.dacast.com/js/player.js?contentId=${contentId}`;
    script.type = "application/javascript";
    script.async = true;
    script.className = "dacast-video";

    script.onload = onLoad;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [contentId, onLoad]);
};

export default useScript;
